import { render, staticRenderFns } from "./PresentationPreview.vue?vue&type=template&id=40316da2&scoped=true&"
import script from "./PresentationPreview.vue?vue&type=script&lang=js&"
export * from "./PresentationPreview.vue?vue&type=script&lang=js&"
import style0 from "./PresentationPreview.vue?vue&type=style&index=0&id=40316da2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40316da2",
  null
  
)

export default component.exports